export default __webpack_public_path__ + "static/Mask-Group-250-854d221cf194b1e8fe1f9272fb3b4770.png";